<template>
  <div id="app">
    <a class="skip" href="#content">本文へスキップ</a>
    <!-- ヘッダー -->
    <header class="header">
      <div class="container header__inner">
  <router-link class="brand brand--script" :to="{ path: '/', hash: '#top' }">Kiss Shot</router-link>
        <nav class="nav" aria-label="主要メニュー">
          <router-link :to="{ path: '/', hash: '#top' }">トップ</router-link>
          <router-link :to="{ path: '/', hash: '#pricing' }">料金案内</router-link>
          <router-link :to="{ path: '/', hash: '#gallery' }">ギャラリー</router-link>
          <router-link :to="{ path: '/', hash: '#reviews' }">口コミ</router-link>
          <router-link :to="{ path: '/', hash: '#faq' }">FAQ</router-link>
          <router-link :to="{ path: '/', hash: '#access' }">店舗情報</router-link>
          <a
            class="social"
            href="https://www.instagram.com/kiss_shot_billiards_nago/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            >Instagram</a
          >
        </nav>
      </div>
    </header>

    <!-- メインコンテンツ -->
    <main id="content" class="main" tabindex="-1">
      <!-- ページ先頭のアンカー（ヘッダー offset 用） -->
      <div id="top" aria-hidden="true"></div>
      <router-view />
    </main>

    <!-- フローティングCTA -->
    <div class="floating-cta" aria-label="お問い合わせ">
      <a class="fab fab--instagram" href="https://www.instagram.com/kiss_shot_billiards_nago/" target="_blank" rel="noopener noreferrer" aria-label="Instagramをフォロー">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.17.054 1.97.24 2.43.403a4.08 4.08 0 0 1 1.518.988 4.08 4.08 0 0 1 .988 1.518c.164.46.35 1.26.403 2.43.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.054 1.17-.24 1.97-.403 2.43a4.36 4.36 0 0 1-2.506 2.506c-.46.164-1.26.35-2.43.403-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.17-.054-1.97-.24-2.43-.403a4.08 4.08 0 0 1-1.518-.988 4.08 4.08 0 0 1-.988-1.518c-.164-.46-.35-1.26-.403-2.43C2.175 15.584 2.163 15.204 2.163 12s.012-3.584.07-4.85c.054-1.17.24-1.97.403-2.43a4.08 4.08 0 0 1 .988-1.518 4.08 4.08 0 0 1 1.518-.988c.46-.164 1.26-.35 2.43-.403C8.416 2.175 8.796 2.163 12 2.163M12 0C8.741 0 8.333.014 7.053.072 5.775.13 4.903.333 4.14.63a5.88 5.88 0 0 0-2.126 1.384A5.88 5.88 0 0 0 .63 4.14C.333 4.903.13 5.775.072 7.053.014 8.333 0 8.741 0 12s.014 3.667.072 4.947c.058 1.278.261 2.15.558 2.913a5.88 5.88 0 0 0 1.384 2.126A5.88 5.88 0 0 0 4.14 23.37c.763.297 1.635.5 2.913.558C8.333 23.986 8.741 24 12 24s3.667-.014 4.947-.072c1.278-.058 2.15-.261 2.913-.558a6.14 6.14 0 0 0 3.51-3.51c.297-.763.5-1.635.558-2.913C23.986 15.667 24 15.259 24 12s-.014-3.667-.072-4.947c-.058-1.278-.261-2.15-.558-2.913a5.88 5.88 0 0 0-1.384-2.126A5.88 5.88 0 0 0 19.86.63C19.097.333 18.225.13 16.947.072 15.667.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"/></svg>
      </a>
      <a class="fab fab--line" href="https://line.me/R/ti/p/" target="_blank" rel="noopener noreferrer" aria-label="LINEで問い合わせ">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden="true"><path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386a.63.63 0 0 1-.63-.629V8.108a.63.63 0 0 1 .63-.63h2.386c.349 0 .63.285.63.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016a.63.63 0 0 1-.63.63.625.625 0 0 1-.51-.262l-2.418-3.294v2.926a.63.63 0 0 1-.63.63.63.63 0 0 1-.63-.63V8.108a.63.63 0 0 1 .63-.63c.2 0 .38.095.51.259l2.42 3.296V8.108a.63.63 0 1 1 1.258 0v4.771zm-5.741 0a.63.63 0 0 1-1.26 0V8.108a.63.63 0 0 1 1.26 0v4.771zm-2.527.63H4.856a.63.63 0 0 1-.63-.63V8.108a.63.63 0 0 1 1.26 0v4.14h1.756c.348 0 .629.283.629.63 0 .344-.282.63-.629.63M12 1C5.926 1 1 5.15 1 10.303c0 4.58 4.042 8.424 9.503 9.16.37.08.87.245.997.562.114.288.075.738.036 1.03l-.16.96c-.05.293-.231 1.146.999.625 1.23-.52 6.637-3.912 9.058-6.697C23.175 13.96 23 12.218 23 10.303 23 5.15 18.074 1 12 1"/></svg>
      </a>
      <a class="fab fab--phone" href="tel:0980525595" aria-label="電話で問い合わせ">
        <svg viewBox="0 0 24 24" width="26" height="26" fill="currentColor" aria-hidden="true"><path d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1.02l-2.2 2.2z"/></svg>
      </a>
    </div>

    <!-- フッター -->
    <footer class="footer">
      <div class="container footer__inner">
        <router-link :to="{ path: '/', hash: '#top' }">トップに戻る</router-link>
        <p>&copy; {{ new Date().getFullYear() }} Kiss Shot Billiards & Darts. All rights reserved.</p>
      </div>
    </footer>
  </div>
  
</template>

<script>
export default { name: "App" };
</script>

<style>
/* Shared tokens to align with Home.vue */
:root {
  --bg: #0b0f14;
  --surface: #121924;
  --text: #e8eef6;
  --muted: #a9b6c7;
  --primary: #00d084;
  --primary-600: #00b873;
  --card: #0f1520;
  /* focus ring color (used across components) */
  --ring: var(--primary);
  /* fixed header height for scroll offset */
  --header-h: 96px;
}

body {
  margin: 0;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, "Hiragino Kaku Gothic ProN", "Noto Sans JP", "Yu Gothic", "Meiryo", sans-serif;
  line-height: 1.6;
  background: var(--bg);
  color: var(--text);
}

.skip {
  position: absolute;
  left: 12px;
  top: 10px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #0a0f16;
  border: 1px solid #2a3748;
  color: var(--text);
  text-decoration: none;
  transform: translateY(-140%);
  transition: transform .15s ease;
  z-index: 1100;
}
.skip:focus { transform: translateY(0); }

/* Smooth scrolling for in-page anchors; respects reduced motion */
html { scroll-behavior: smooth; }
@media (prefers-reduced-motion: reduce) { html { scroll-behavior: auto; } }

.container { width: min(1100px, 92%); margin-inline: auto; }

/*
  共通見出し（Home/Gallery等で使用）
  - フォントサイズや余白は各Viewで調整
  - 下線アクセントだけここで共通化
*/
.section-title {
  position: relative;
  display: inline-block;
}
.section-title::after {
  content: "";
  display: block;
  height: 2px;
  width: 44px;
  margin-top: 8px;
  border-radius: 999px;
  background: var(--primary);
  opacity: .9;
}

/* Header */
.header {
  position: fixed;
  inset: 0 0 auto 0;
  background: #0a0f16;
  border-bottom: 1px solid #1b2635;
  z-index: 1000;
}
.header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
}
.brand { color: var(--text); text-decoration: none; font-weight: 800; letter-spacing: .02em; }
.brand--script { font-family: 'Great Vibes', cursive; font-weight: 400; letter-spacing: .02em; }
.nav { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; }
.nav a, .nav .router-link-active, .nav .router-link {
  color: var(--text);
  text-decoration: none;
  opacity: .92;
  padding: 6px 8px;
  border-radius: 10px;
}
.nav a:hover, .nav .router-link:hover { color: var(--primary); }
.nav .router-link-active {
  color: var(--primary);
  opacity: 1;
  box-shadow: inset 0 -2px 0 var(--primary);
}
.nav .social { border: 1px solid #2a3748; border-radius: 8px; padding: 6px 10px; }

.nav a:focus-visible, .nav .router-link:focus-visible {
  outline: 2px solid var(--ring);
  outline-offset: 2px;
  border-radius: 8px;
}

@media (hover: hover) {
  .nav a:hover, .nav .router-link:hover { background: #0e1621; }
}

/* Main with header offset */
.main { padding: 96px 0 0; }

/* Offset anchors so fixed header doesn't cover them */
#top, #pricing, #access, #gallery, #instagram, #reviews, #faq { scroll-margin-top: var(--header-h); }

/* Footer */
.footer { border-top: 1px solid #1b2635; background: #0a0f16; color: var(--text); }
.footer__inner { display: flex; justify-content: space-between; align-items: center; gap: 10px; padding: 16px 0; }
.footer a { color: var(--text); text-decoration: none; opacity: .9; }
.footer a:hover { color: var(--primary); }

@media (max-width: 600px) {
  .main { padding-top: 88px; }
  :root { --header-h: 88px; }

  /* Keep header height stable on small screens */
  .header__inner { align-items: center; }
  .nav {
    flex-wrap: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    gap: 10px;
  }
  .nav::-webkit-scrollbar { display: none; }
  .nav a, .nav .router-link { white-space: nowrap; }
}

/* Floating CTA */
.floating-cta {
  position: fixed;
  bottom: 24px;
  right: 20px;
  z-index: 900;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.fab {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0,0,0,0.35);
  transition: transform .15s ease, box-shadow .15s ease;
}
.fab:hover { transform: scale(1.08); box-shadow: 0 6px 20px rgba(0,0,0,0.45); }
.fab:focus-visible { outline: 2px solid var(--ring); outline-offset: 3px; }
.fab--phone { background: var(--primary); }
.fab--line { background: #06C755; }
.fab--instagram { background: linear-gradient(135deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888); }

@media (prefers-reduced-motion: reduce) {
  .fab { transition: none; }
  .fab:hover { transform: none; }
}

/* Utility: narrow media container (used for the square carousel) */
.media-box { max-width: 900px; width: 92%; margin: 0 auto; }
</style>
